































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import { IBulkAction } from "@/models/bulkactions";
import HasValidation from "@/mixins/HasValidation";
import { BACKEND_DATETIME_FORMAT } from "@/data/date";
import { NotificationChannelCodes } from "@/data/enums/notifications";
import { ISegmentTypes } from "@/data/enums/segments";
import { SegmentTypesMap } from "@/data/segments";
import { TemplateTypes } from "@/data/enums/templates";
import TemplatesProvider from "@/components/app/global/templates/templatesProvider.vue";
import TemplatesSelectField from "@/components/app/global/templates/templatesSelectField.vue";
import { ISegment } from "@/models/segments";

@Component({
  components: {
    TemplatesProvider,
    TemplatesSelectField,
    "segments-autocomplete": () =>
      import("@/components/app/global/fields/segmentsAutocomplete.vue")
  }
})
export default class AddEditBulkAction extends Mixins(
  RequestPromises,
  HasValidation
) {
  @Prop({ required: true })
  public bulkAction!: IBulkAction;

  @Prop({ required: true })
  public segmentType!: ISegmentTypes;

  public form: any = {
    id: undefined,
    name: "",
    action_type: "notification",
    action_data: {},
    segment_id: "",
    refresh_segment: true,
    started_at: undefined,
    status: {}
  };

  public formClone = {} as IBulkAction;
  public templateType = TemplateTypes.NOTIFICATION;
  public emailChannelCode = NotificationChannelCodes.EMAIL;
  public segmentFilter = "";
  public scheduled = false;
  public scheduleDate: Date = new Date();
  public scheduleDateClone: Date = new Date();

  public isProcessing = false;
  public isLoading = true;
  public availableSegmentTypes = SegmentTypesMap().filter(i =>
    [
      ISegmentTypes.CLIENT,
      ISegmentTypes.CONTRACTS_PRODUCTS,
      ISegmentTypes.ORDER
    ].includes(i.value)
  );

  public backEndDateFormat = BACKEND_DATETIME_FORMAT;
  public selectedSegmentType = this.segmentType;

  public async created() {
    try {
      if (!this.contentIsAvailable) {
        return;
      }
      this.isLoading;

      this.form = { ...this.form, ...this.bulkAction };
      this.formClone = this.$_.cloneDeep(this.form);

      if (this.isEditing) this.loadEditData();
    } finally {
      this.isLoading = false;
    }
  }

  public get contentIsAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }

  public get guardFunctionalities() {
    return this.isEditing
      ? ["update_bulk_action", "get_bulk_action"]
      : ["create_bulk_action"];
  }

  public get isEditing() {
    return !this.$_.isEmpty(this.bulkAction);
  }

  public get canUpdateBulkAction() {
    if (this.form.id) {
      return this.$userCan("update_bulk_action");
    }
    return true;
  }

  public get allowEdit() {
    // new
    if (!this.isEditing) {
      return true;
    }

    return ["bulk_action_scheduled", "bulk_action_draft"].includes(
      this.$_.get(this.bulkAction, "status.code", 0)
    );
  }

  public get selectedSegment() {
    return this.$_.find(this.segments, s => s.id === this.form.segment_id);
  }

  public get selectedSegmentCategoryCode() {
    const type = this.selectedSegment?.type;
    return type?.split(".")[0];
  }

  public get segments(): ISegment[] {
    return this.$store.getters[`data/list`]({
      storeModule: DataModules.SEGMENTS
    });
  }

  public get filteredSegments() {
    return this.$_.filter(this.segments, segment => {
      return this.$_.includes(
        segment.name.toLowerCase(),
        this.segmentFilter.toLowerCase()
      );
    });
  }

  public get formIsValid() {
    if (this.$_.isEmpty(this.form.name)) {
      return false;
    }
    if (this.scheduled && !this.$_.isDate(this.scheduleDate)) {
      return false;
    }
    return Boolean(this.form.action_data.template_id && this.form.segment_id);
  }

  public get formIsDisabled() {
    return (
      !this.allowEdit ||
      this.isProcessing ||
      !this.formIsValid ||
      this.hasErrors ||
      this.isLoading
    );
  }

  public get hasChange() {
    return (
      !this.$_.isEqual(this.form, this.formClone) ||
      !this.$_.isEqual(this.scheduleDate, this.scheduleDateClone)
    );
  }

  // Methods

  public revertToInitialState() {
    this.form = this.$_.cloneDeep(this.formClone);
    this.scheduleDate = this.$_.cloneDeep(this.scheduleDateClone);
  }

  public onSelectSegment(segment) {
    if (!segment) return;
    this.form.segment_id = this.$_.get(segment, "id", "");
  }

  public onTemplateSelected(template) {
    if (!template) return;

    this.$set(
      this.form.action_data,
      "template_id",
      this.$_.get(template, "id")
    );
    if (this.$_.isEmpty(this.form.name)) {
      this.form.name = this.$_.get(template, "name", "");
    }
  }

  public loadEditData() {
    this.scheduled = this.bulkAction.status.code === "bulk_action_scheduled";
    this.scheduleDate = this.$moment
      .utc(this.bulkAction.started_at)
      .local()
      .toDate();

    this.scheduleDateClone = this.$_.cloneDeep(this.scheduleDate);
  }

  public save() {
    const fields = [
      "name",
      "action_data",
      "action_type",
      "segment_id",
      "refresh_segment",
      "started_at",
      "draft"
    ];
    const payload = this.$_.pick(this.form, fields);

    payload.started_at = this.scheduled
      ? this.$moment(this.scheduleDate)
          .utc()
          .format(this.backEndDateFormat)
      : this.$moment()
          .utc()
          .format(this.backEndDateFormat);

    if (this.isEditing) {
      return this.$store.dispatch(`data/${DataModules.BULK_ACTIONS}/update`, {
        id: this.bulkAction.id,
        data: { ...payload, draft: true }
      });
    }

    return this.$store.dispatch(`data/${DataModules.BULK_ACTIONS}/create`, {
      data: { ...payload, draft: !this.scheduled }
    });
  }

  public validateBeforeSubmit() {
    if (!this.canUpdateBulkAction) {
      return;
    }

    this.isProcessing = true;
    this.validate()
      .then(result => {
        if (result) {
          return this.save();
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then(() => {
        this.$store.dispatch("toast/show", {
          message: this.$t("_sentence.successfully_saved")
        });

        this.$emit("success");
        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  public getFirstSegmentResultObject() {
    return this.$store.dispatch(`data/${DataModules.SEGMENTS_RESULTS}/list`, {
      storeData: false,
      params: { limit: 1 }
    });
  }
}
